/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.
/**
 * @deprecated Use `import { mediaState } from '@atlaskit/media-core/cache'` instead.
 */
export { mediaState } from './cache';
/**
 * @deprecated Use `import type { CachedMediaState, StateDeferredValue } from '@atlaskit/media-core/cache'` instead.
 */
export type { CachedMediaState, StateDeferredValue } from './cache';
/**
 * @deprecated Use `import { isClientBasedAuth, isAsapBasedAuth, authToOwner } from '@atlaskit/media-core/auth'` instead.
 */
export { authToOwner } from './authToOwner';
export { isAsapBasedAuth } from './isAsapBasedAuth';
/**
 * @deprecated Use `import { isClientBasedAuth } from '@atlaskit/media-core'` instead.
 */
export { isClientBasedAuth } from './isClientBasedAuth';
/**
 * @deprecated Use `import type { ClientBasedAuth, AsapBasedAuth, ClientAltBasedAuth, Auth, AuthContext, AuthProvider, MediaApiConfig, MediaClientConfig } from '@atlaskit/media-core/auth'` instead.
 */
export type {
	ClientBasedAuth,
	AsapBasedAuth,
	ClientAltBasedAuth,
	Auth,
	AuthContext,
	AuthProvider,
	MediaApiConfig,
	MediaClientConfig,
} from './auth';
/**
 * @deprecated Use `import { ChunkHashAlgorithm } from '@atlaskit/media-core/chunk-hash-algorithm'` instead.
 */
export { ChunkHashAlgorithm } from './ChunkHashAlgorithm';
